/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Property_Registry_Lv_SuccessInputs */

const cs_property_registry_lv_success = /** @type {(inputs: Property_Registry_Lv_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Výpis LV uložen do dokumentů (−${i?.credits} kreditů)`)
};

const en_property_registry_lv_success = /** @type {(inputs: Property_Registry_Lv_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`LV extract saved to documents (−${i?.credits} credits)`)
};

/**
* | output |
* | --- |
* | "LV extract saved to documents (−{credits} credits)" |
*
* @param {Property_Registry_Lv_SuccessInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_lv_success = /** @type {((inputs: Property_Registry_Lv_SuccessInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Lv_SuccessInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_lv_success(inputs)
	return cs_property_registry_lv_success(inputs)
});